/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1542__part-2
 */

"use strict"

import { A } from "./1542__part-0"
import { m, b, w, E, C } from "./1542__part-1"
import * as /* [auto-meaningful-name] */Module_107 from /* 107 */"../107"
import * as /* [auto-meaningful-name] */Module_140 from /* 140 */"../140"
import * as /* [auto-meaningful-name] */Module_120 from /* 120 */"../120"
import * as /* [auto-meaningful-name] */Module_106 from /* 106 */"../106"
import * as /* [auto-meaningful-name] */Module_103 from /* 103 */"../103"
import { createRef, createElement, Component } from /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_79 from /* 79 */"../79/index"
var k = []
var S = new RegExp("".concat("ant-scrolling-effect"), "g")
var T = 0
var B = new Map()
var D = function e(t) {
  var n = this
  Module_103.a(this, e)
  this.lockTarget = undefined
  this.options = undefined
  this.getContainer = function () {
    var /* [auto-meaningful-name] */n$options
    return null === (n$options = n.options) || undefined === n$options ? undefined : n$options.container
  }
  this.reLock = function (e) {
    var t = k.find(function (e) {
      return e.target === n.lockTarget
    })
    if (t) {
      n.unLock()
    }
    n.options = e
    if (t) {
      t.options = e
      n.lock()
    }
  }
  this.lock = function () {
    var /* [auto-meaningful-name] */n$options
    if (!k.some(function (e) {
      return e.target === n.lockTarget
    })) {
      if (k.some(function (e) {
        var /* [auto-meaningful-name] */n$options1
        var /* [auto-meaningful-name] */e$options = e.options
        return (null === e$options || undefined === e$options ? undefined : e$options.container) === (null === (n$options1 = n.options) || undefined === n$options1 ? undefined : n$options1.container)
      })) {
        k = [].concat(Module_79.a(k), [
          {
            target: n.lockTarget,
            options: n.options
          }
        ])
      } else {
        var t = 0
        var r = (null === (n$options = n.options) || undefined === n$options ? undefined : n$options.container) || document.body
        if (r === document.body && window.innerWidth - document.documentElement.clientWidth > 0 || r.scrollHeight > r.clientHeight) {
          t = w()
        }
        var /* [auto-meaningful-name] */r$className = r.className
        if (0 === k.filter(function (e) {
          var /* [auto-meaningful-name] */n$options1
          var /* [auto-meaningful-name] */e$options = e.options
          return (null === e$options || undefined === e$options ? undefined : e$options.container) === (null === (n$options1 = n.options) || undefined === n$options1 ? undefined : n$options1.container)
        }).length) {
          B.set(r, E({
            width: 0 !== t ? "calc(100% - ".concat(t, "px)") : undefined,
            overflow: "hidden",
            overflowX: "hidden",
            overflowY: "hidden"
          }, {
            element: r
          }))
        }
        if (!S.test(r$className)) {
          var o = "".concat(r$className, " ").concat("ant-scrolling-effect")
          r.className = o.trim()
        }
        k = [].concat(Module_79.a(k), [
          {
            target: n.lockTarget,
            options: n.options
          }
        ])
      }
    }
  }
  this.unLock = function () {
    var /* [auto-meaningful-name] */n$options
    var t = k.find(function (e) {
      return e.target === n.lockTarget
    })
    k = k.filter(function (e) {
      return e.target !== n.lockTarget
    })
    if (t && !k.some(function (e) {
      var /* [auto-meaningful-name] */t$options
      var /* [auto-meaningful-name] */e$options = e.options
      return (null === e$options || undefined === e$options ? undefined : e$options.container) === (null === (t$options = t.options) || undefined === t$options ? undefined : t$options.container)
    })) {
      var r = (null === (n$options = n.options) || undefined === n$options ? undefined : n$options.container) || document.body
      var /* [auto-meaningful-name] */r$className = r.className
      if (S.test(r$className)) {
        E(B.get(r), {
          element: r
        })
        B.delete(r)
        r.className = r.className.replace(S, "").trim()
      }
    }
  }
  this.lockTarget = T++
  this.options = t
}
var I = 0
var R = m()
var F = {}
var P = function (e) {
  if (!R) {
    return null
  }
  if (e) {
    if ("string" === typeof e) {
      return document.querySelectorAll(e)[0]
    }
    if ("function" === typeof e) {
      return e()
    }
    if ("object" === Module_107.a(e) && e instanceof window.HTMLElement) {
      return e
    }
  }
  return document.body
}
var N = function (e) {
  Module_120.a(n, e)
  var t = Module_140.a(n)
  function n(e) {
    var r
    Module_103.a(this, n);
    (r = t.call(this, e)).container = undefined
    r.componentRef = createRef()
    r.rafId = undefined
    r.scrollLocker = undefined
    r.renderComponent = undefined
    r.updateScrollLocker = function (e) {
      var /* [auto-meaningful-name] */E$visible = (e || {}).visible
      var /* [auto-meaningful-name] */r$props = r.props
      var /* [auto-meaningful-name] */r$props$getContainer = r$props.getContainer
      var /* [auto-meaningful-name] */r$props$visible = r$props.visible
      if (r$props$visible && r$props$visible !== E$visible && R && P(r$props$getContainer) !== r.scrollLocker.getContainer()) {
        r.scrollLocker.reLock({
          container: P(r$props$getContainer)
        })
      }
    }
    r.updateOpenCount = function (e) {
      var t = e || {}
      var /* [auto-meaningful-name] */t$visible = t.visible
      var /* [auto-meaningful-name] */t$getContainer = t.getContainer
      var /* [auto-meaningful-name] */r$props = r.props
      var /* [auto-meaningful-name] */r$props$visible = r$props.visible
      var /* [auto-meaningful-name] */r$props$getContainer = r$props.getContainer
      if (r$props$visible !== t$visible && R && P(r$props$getContainer) === document.body) {
        if (r$props$visible && !t$visible) {
          I += 1
        } else {
          if (e) {
            I -= 1
          }
        }
      }
      if ("function" === typeof r$props$getContainer && "function" === typeof t$getContainer ? r$props$getContainer.toString() !== t$getContainer.toString() : r$props$getContainer !== t$getContainer) {
        r.removeCurrentContainer()
      }
    }
    r.attachToParent = function () {
      var e = arguments.length > 0 && undefined !== arguments[0] && arguments[0]
      if (e || r.container && !r.container.parentNode) {
        var t = P(r.props.getContainer)
        return !!t && (t.appendChild(r.container), true)
      }
      return true
    }
    r.getContainer = function () {
      return R ? (r.container || (r.container = document.createElement("div"), r.attachToParent(true)), r.setWrapperClassName(), r.container) : null
    }
    r.setWrapperClassName = function () {
      var /* [auto-meaningful-name] */r$props$wrapperClassName = r.props.wrapperClassName
      if (r.container && r$props$wrapperClassName && r$props$wrapperClassName !== r.container.className) {
        r.container.className = r$props$wrapperClassName
      }
    }
    r.removeCurrentContainer = function () {
      var /* [auto-meaningful-name] */r$container
      var /* [auto-meaningful-name] */r$container$parentNode
      if (!(null === (r$container = r.container) || undefined === r$container || null === (r$container$parentNode = r$container.parentNode) || undefined === r$container$parentNode)) {
        r$container$parentNode.removeChild(r.container)
      }
    }
    r.switchScrollingEffect = function () {
      if (1 !== I || Object.keys(F).length) {
        if (!I) {
          E(F)
          F = {}
          C(true)
        }
      } else {
        C()
        F = E({
          overflow: "hidden",
          overflowX: "hidden",
          overflowY: "hidden"
        })
      }
    }
    r.scrollLocker = new D({
      container: P(e.getContainer)
    })
    return r
  }
  Module_106.a(n, [
    {
      key: "componentDidMount",
      value: function () {
        var e = this
        this.updateOpenCount()
        if (!this.attachToParent()) {
          this.rafId = A(function () {
            e.forceUpdate()
          })
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function (e) {
        this.updateOpenCount(e)
        this.updateScrollLocker(e)
        this.setWrapperClassName()
        this.attachToParent()
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        var /* [auto-meaningful-name] */this$props = this.props
        var /* [auto-meaningful-name] */this$props$visible = this$props.visible
        var /* [auto-meaningful-name] */this$props$getContainer = this$props.getContainer
        if (R && P(this$props$getContainer) === document.body) {
          I = this$props$visible && I ? I - 1 : I
        }
        this.removeCurrentContainer()
        A.cancel(this.rafId)
      }
    }, {
      key: "render",
      value: function () {
        var /* [auto-meaningful-name] */this$props = this.props
        var /* [auto-meaningful-name] */this$props$children = this$props.children
        var /* [auto-meaningful-name] */this$props$forceRender = this$props.forceRender
        var /* [auto-meaningful-name] */this$props$visible = this$props.visible
        var i = null
        var a = {
          getOpenCount: function () {
            return I
          },
          getContainer: this.getContainer,
          switchScrollingEffect: this.switchScrollingEffect,
          scrollLocker: this.scrollLocker
        }
        if (this$props$forceRender || this$props$visible || this.componentRef.current) {
          i = createElement(b, {
            getContainer: this.getContainer,
            ref: this.componentRef
          }, this$props$children(a))
        }
        return i
      }
    }
  ])
  return n
}(Component)
export { N }
